/**
 * Analytics flow tag for /onboarding pages. The legacy name `V3_ANALYTICS` is kept so the
 * hooks (useGoogleAuth, useOutlookAuth) — which are shared with AuthHub — don't need touching;
 * only the FLOW string was updated as part of the funnel-event cleanup.
 */
export const V3_ANALYTICS = {
    FLOW: 'onboarding',
} as const

/** Alias so new page-level code can use a name that matches the renamed folder. */
export const ONBOARDING_ANALYTICS = V3_ANALYTICS

export const CHROME_STORE_URL = 'https://chromewebstore.google.com/detail/loadops-ai/mfhpdapldnbmejcanhlbbmjlojncicfj'

export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || ''

export const OUTLOOK_CLIENT_ID = process.env.REACT_APP_OUTLOOK_CLIENT_ID || ''

export const NYLAS_CLIENT_ID = process.env.REACT_APP_NYLAS_CLIENT_ID || ''
export const NYLAS_API_URL = process.env.REACT_APP_NYLAS_API_URL || ''
